// @ts-strict-ignore
import type {
  FacetsService,
  NextQueriesCrudService,
  QueryRankingService,
  RelatedTagsCrudService,
} from '@empathyco/playboard-core-domain'

import type { EqualizeCrudService } from '../modules/equalize'
import type { PromotionCrudService } from '../modules/promotion'
import type { CrudServiceProvider } from './interfaces'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { FeatureIdEnum } from '../enums'
import Context = interfaces.Context

export function getCrudServiceProvider({ container }: Context): CrudServiceProvider {
  return id => {
    switch (id) {
      case FeatureIdEnum.EQUALIZE:
        return container.get<EqualizeCrudService>(TYPES.EqualizeCrudService)
      case FeatureIdEnum.NEXT_QUERIES:
        return container.get<NextQueriesCrudService>(TYPES.NextQueriesCrudService)
      case FeatureIdEnum.RELATED_TAGS:
        return container.get<RelatedTagsCrudService>(TYPES.RelatedTagsCrudService)
      case FeatureIdEnum.CONFIGURATION:
        return container.get<QueryRankingService>(TYPES.QueryRankingService)
      case FeatureIdEnum.FACETS:
        return container.get<FacetsService>(TYPES.FacetsService)
      case FeatureIdEnum.PROMOTION:
        return container.get<PromotionCrudService>(TYPES.PromotionCrudService)
      default:
        throw new Error(`CRUD service provider not found for "${id}"`)
    }
  }
}
